query materials($companyId: ID!) {
  materials(companyId: $companyId) {
    id
    type
    purpose
    mode
    campaignId
    landingpageId
    filesCount
    version
    hasFile
    displayName
    createdAt
    updatedAt
  }
}
